var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfHidePassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  className: "dd-privacy-hidden"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "lf-hide-password_svg__a",
  cx: 15,
  cy: 15,
  r: 15
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#lf-hide-password_svg__a"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.764 12c1.655 0 3 1.345 3 3s-1.345 3-3 3-3-1.345-3-3 1.345-3 3-3Zm.228 2.11c.372 0 .682.31.682.683h.993c-.02-.93-.765-1.676-1.675-1.676v.993Z",
  fill: "#F4CC54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.66 14.38C6.674 13.116 10.295 9 14.764 9c4.469 0 8.09 4.117 9.103 5.38.29.351.29.868 0 1.24-1.013 1.263-4.634 5.38-9.103 5.38-4.469 0-8.09-4.117-9.104-5.38a.995.995 0 0 1 0-1.24Zm9.104 4.965a4.344 4.344 0 1 0 .001-8.689 4.344 4.344 0 0 0-.001 8.689Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.866 19.5a1 1 0 1 0 1 1.732l19.053-11a1 1 0 0 0-1-1.732l-19.053 11Z",
  fill: "#405B73"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.266 18.46 19.053-11a2.2 2.2 0 0 1 2.2 3.811l-19.053 11a2.2 2.2 0 1 1-2.2-3.81Zm.6 1.04a1 1 0 1 0 1 1.732l19.053-11a1 1 0 0 0-1-1.732l-19.053 11Z",
  fill: "#FFF"
})))));
export default SvgLfHidePassword;